import { createGlobalStyle } from 'styled-components'
import theme from 'themes/main'

export default createGlobalStyle`
  html {
    font-size: 16px;
  }
  body {
    font-family: ${theme.fontFamily};
    box-sizing: border-box;
    color: ${theme.colors.textBase};

    &.modal-open {
      overflow: hidden;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    font-family: ${theme.fontFamilyBold};
    font-weight: 400;
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${theme.colors.headerBase};
  }

  h1 {
    font-size: 2.625rem;
    line-height: 3rem;

    ${theme.breakpoints.mobile} {
      font-size: 2.325rem;
      line-height: 2.75rem;
    }
  }

  h2 {
    font-size: 1.75rem;
    line-height: 2.125rem;

    ${theme.breakpoints.mobile} {
      font-size: 1.625rem;
      line-height: 2rem;
    }
  }

  h3 {
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  h4 {
    font-size: 1.25rem;
    line-height: 1.625rem;
  }

  h5 {
    font-size: 1.125rem;
    line-height: 1.375rem;
  }

  h6 {
    font-size: 1rem;
    line-height: 1.375rem;
  }

  p, a {
    font-size: 1rem;
    line-height: 1.375rem;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  a {
    color: ${theme.linkBase};
  }

  div[data-reach-dialog-overlay] {
    z-index: 2;
  }

  [class*="SelectContainer"] span {
    margin-bottom: 0;
  }
  #date-picker__drop{
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    border: solid 0.0625rem #ced8df;
    border-radius: 0.3125rem;
    background-color: #fff;
    box-shadow: none;
    z-index: 1;
  }
  #date-picker__select-drop {
    button div{
      padding: 0.625rem 1rem 0.625rem;
    }
  }

  #select-grade__select-drop, #select-license__select-drop {
    button:focus:not(:focus-visible) {
      cursor: default !important;
      color: ${theme.global.hover.color};
      background-color: ${theme.global.hover.background};
    }



    button:focus-visible {
      cursor: default !important
      pointer-events: none !important;
      color: ${theme.global.hover.color};
      background-color: ${theme.global.hover.background};
    }
  }

  #select-license__drop {
    width: 420px;
  }

  #select-license__drop, #select-grade__select-drop {
    box-shadow: none;
    border-right: 1.5px solid ${theme.colors.blueGrayMedium};
    border-left: 1.5px solid ${theme.colors.blueGrayMedium};
    border-bottom: 1.5px solid ${theme.colors.blueGrayMedium};
    border-radius: 0 0 5px 5px;
  }  

  #select-license__select-drop {
    max-height: 240px;
  }
`
